<template>
	<div
		class="empty-tab__wrapper"
		:class="{ 'empty-tab__wrapper--dark': darkTheme }"
	>
		<div class="empty-tab">
			<div v-if="customerNameToPrint" class="empty-tab__customer-name">
				{{ customerNameToPrint }}
			</div>

			<div
				class="empty-tab__text animation-transition"
				:class="{ 'initial-opacity': !isAnimationComplete }"
			>
				YOUR
			</div>

			<div
				class="empty-tab__logo mb-15 animation-transition"
				:class="{ 'initial-opacity': !isAnimationComplete }"
			>
				<img alt="logo" :src="darkTheme ? whiteLogoIcon : logoIcon" />
			</div>

			<div
				class="empty-tab__text empty-tab__text--open mb-7 animation-transition"
				:class="{ 'initial-translate': !isAnimationComplete }"
			>
				IS OPEN
			</div>

			<check-mark-animation @animation-complete="animationComplete" />

			<div class="empty-tab__card mt-10 mb-12">
				<div class="empty-tab__card__bg-icon">
					<img alt="background icon" :src="darkTheme ? bGIconBlue : bGIcon" />
				</div>
			</div>

			<div
				class="empty-tab__card__title mb-10 animation-transition"
				:class="{ 'initial-opacity': !isAnimationComplete }"
			>
				PLACE AN ORDER
			</div>

			<div
				class="empty-tab__card__subtitle mb-24 animation-transition"
				:class="{ 'initial-translate': !isAnimationComplete }"
			>
				At the bar or with a server
			</div>
		</div>
	</div>
</template>

<script>
import LogoIcon from '@/assets/images/logo.svg'
import WhiteLogoIcon from '@/assets/images/logo_white.svg'
import BGIcon from '@/assets/images/logo_square_white.svg'
import BGIconBlue from '@/assets/images/logo_square_blue.svg'
import CheckMarkAnimation from '@/components/Loaders/CheckMarkAnimation.vue'

export default {
	name: 'EmptyTicketingTab',

	components: {
		CheckMarkAnimation
	},

	props: {
		customerNameToPrint: {
			type: String,
			default: ''
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			isAnimationComplete: false
		}
	},

	computed: {
		logoIcon: () => LogoIcon,
		whiteLogoIcon: () => WhiteLogoIcon,
		bGIcon: () => BGIcon,
		bGIconBlue: () => BGIconBlue
	},

	methods: {
		animationComplete() {
			this.isAnimationComplete = true
			this.$emit('show-empty-current-tab-footer')
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.empty-tab__wrapper {
	overflow: hidden;
	position: relative;
	height: calc(100vh - 47px);

	&--dark {
		.empty-tab__text,
		.empty-tab,
		.empty-tab__card__title {
			color: $white;
		}

		.empty-tab {
			background: $background-dark;
		}
	}
}

.empty-tab {
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: auto;
	height: 100%;
	padding-bottom: 12px;
	text-align: center;
	color: $grey-dark;
	font-size: 16px;
	line-height: 22px;
	background-color: $white;

	&__customer-name {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 33px 10px 16px;
		font-weight: 300;
		font-size: 24px;
		letter-spacing: 0.5px;
	}

	&__logo {
		width: 199px;
		height: 50px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	&__text {
		font-weight: 300;
		color: $grey-awesome;

		&--open {
			font-size: 28px;
			letter-spacing: 2px;
		}
	}

	&__card {
		position: relative;
		min-height: 126px;
		width: 640px;
		padding: 0 10px 10px;

		&__subtitle {
			font-size: 28px;
			text-transform: lowercase;
			font-weight: 300;
			z-index: 1;
		}

		&__title {
			font-size: 40px;
			color: $blue-awesome;
			z-index: 1;
		}

		&__bg-icon {
			img {
				width: 189px;
				height: 226px;
			}
		}
	}

	@media (max-width: 767px) {
		padding-left: 16px;
		padding-right: 16px;

		&__customer-name {
			margin-top: 20px;
			margin-bottom: 15px;
		}

		&__logo {
			width: 219px;
			height: 45px;
		}

		&__card {
			width: 100%;

			img {
				height: 20vh;
			}
		}
	}

	@media (max-width: 401px) {
		.empty-tab__card__title {
			font-size: 32px;
		}

		.empty-tab__card__subtitle {
			font-size: 24px;
		}
	}
}

.animation-transition {
	transition: opacity 2s, transform 1s;
}

.initial-opacity {
	opacity: 0.3;
	transition: opacity 1.5s;
}

.initial-translate {
	transform: translateX(-1200px);
}
</style>
